import { sendRequest } from 'config/api';

/**
 * User + profile requests, verified against peerless-3-api.
 *
 *   GET   /auth/users/{id}/   full profile (UserSerializer)
 *   PATCH /auth/users/{id}/   update profile
 *   POST  /auth/users/        create a user
 *
 * NOTE: `/auth/account/` is NOT user accounts -- it is the bank-account model
 * (account_number, account_name, bank). Creating a person goes to /auth/users/.
 *
 * POST /auth/users/ takes no `company` field in the body. It defaults to the
 * creating admin's own company, but a SUPERADMIN can target another with
 * `?company=<id>`. It sets the password itself and emails an invite unless
 * `no_email` is present in the query string.
 */

export const USERS_URL = '/auth/users';

export const fetchProfile = (userId: string) =>
  sendRequest(`${USERS_URL}/${userId}/`);

export const updateProfile = (userId: string, payload: any) =>
  sendRequest(`${USERS_URL}/${userId}/`, payload, 'PATCH');

export const createUser = (
  payload: any,
  sendInvite = false,
  companyId?: string
) => {
  const params = new URLSearchParams();
  if (!sendInvite) params.set('no_email', 'true');
  if (companyId) params.set('company', companyId);
  const query = params.toString();
  return sendRequest(`${USERS_URL}/${query ? `?${query}` : ''}`, payload, 'POST');
};
